import gql from 'graphql-tag'
export default gql`
query AspectRatios {
    AspectRatios {
        id
        name
        widthUnits
        heightUnits
        currentlyInUse
      }
    }
  `
